export default [
    {
        "title": "Instalike PWA",
        "text": "Pour Epitech, nous devions développer une Progressive Web App. Nous avons réalisé une application de partage de photos. Nous avons utilisé Vue.Js pour le front-end et Express.Js pour le back-end. J'étais responsable du front-end.",
        "tags": [
            {
                "name": "Vue.Js",
                "color": "is-link"
            },
            {
                "name": "Typescript",
                "color": "is-primary"
            },
            {
                "name": "Tailwind",
                "color": "is-primary"
            }
        ],
        "link": "https://instalike.online/",
        "company": "Epitech",
        "image": "assets/images/instalike.svg"
    },
    {
        "title": "Export de données",
        "text": "Pendant cette courte mission de 12 jours, j'ai du exporter des données présentes dans une application Typescript vers un format précis en JSON et en Excel. J'ai du également transformer une application C# en Typescript.",
        "tags": [
            {
                "name": "Typescript",
                "color": "is-primary"
            },
            {
                "name": "C#",
                "color": "is-link"
            },
            {
                "name": "Vue.Js",
                "color": "is-primary"
            }
        ],
        "link": "https://v2.mapview.fr/",
        "company": "ISAAN",
        "image": "assets/images/isaan.svg"
    },
    {
        "title": "Marketplace dentaire",
        "text": "Durant 1 mois, j'ai realisé le front-end du back-office, l'intégration du système de mail ainsi que la connexion aux API Shopify et Prestashop pour gérer l'import de commande et la prise de commande.",
        "tags": [
            {
                "name": "React.Js",
                "color": "is-primary"
            },
            {
                "name": "Node.Js",
                "color": "is-info"
            },
            {
                "name": "Tailwind",
                "color": "is-primary"
            },
            {
                "name": "GCP",
                "color": "is-success"
            }
        ],
        "link": "https://www.okab.io/",
        "company": "Okab",
        "image": "assets/images/okab.webp"
    },
    {
        "title": "Solution d'état civil",
        "text": "Durant 1 an et demi j'ai été chargé de développer des composants afin de créer une application web permettant de gérer l'état civil d'un pays.",
        "tags": [
            {
                "name": "React.Js",
                "color": "is-primary"
            },
            {
                "name": "Java",
                "color": "is-info"
            }
        ],
        "link": "https://digitech-development.com/fr/",
        "company": "Digitech",
        "image": "assets/images/digitech.webp"
    },
    {
        "title": "Générateur de PDF",
        "text": "La mission consistait à créer un générateur de PDF grâce à Puppeteer et NodeJS. J'ai également déployé la solution sur Azure.",
        "tags": [
            {
                "name": "Javascript",
                "color": "is-primary"
            },
            {
                "name": "Node.Js",
                "color": "is-info"
            },
            {
                "name": "Puppeteer",
                "color": "is-link"
            },
            {
                "name": "Azure",
                "color": "is-success"
            }
        ],
        "company": "Adecco Group",
        "image": "assets/images/adecco.webp",
        "link": "https://creation-cv.adecco.fr/"
    },
    {
        "title": "Traduction automatique",
        "text": "Lors de cette mission, j'ai réalisé un outil de traduction de fichier json, xml et js à l'aide de Node.Js, Electron et l'API de Deepl.",
        "tags": [
            {
                "name": "Node.Js",
                "color": "is-info"
            },
            {
                "name": "Electron",
                "color": "is-link"
            },
            {
                "name": "Bootstrap",
                "color": "is-primary"
            }
        ],
        "company": "Oxatis",
        "image": "assets/images/oxatis.webp"
    }
]